<template>
	<div class="container" @keyup.enter="login">
		<!-- 动态背景 -->
		<div class="bg-animation"></div>

		<!-- 登录卡片 -->
		<div class="login-card">
			<el-form label-width="0px" style="width: 100%;">
				<div class="login-header">
					<h2>后台管理系统</h2>
					<p>Management System</p>
				</div>

				<!-- 用户名 -->
				<el-form-item>
					<el-input 
						size="large" 
						placeholder="请输入用户名" 
						clearable 
						prefix-icon="el-icon-user"
						v-model="user.username" 
					></el-input>
				</el-form-item>

				<!-- 密码 + 显示隐藏 -->
				<el-form-item>
					<el-input 
						size="large" 
						:type="passwordVisible ? 'text' : 'password'" 
						placeholder="请输入密码" 
						clearable 
						prefix-icon="el-icon-key"
						v-model="user.password"
					>
						<template slot="suffix">
							<i 
								class="el-icon-view" 
								style="cursor:pointer;font-size:16px;color:#999" 
								@click="passwordVisible = !passwordVisible"
							></i>
						</template>
					</el-input>
				</el-form-item>

				<!-- 验证码 -->
				<el-form-item>
					<div class="captcha-row">
						<el-input 
							size="large" 
							placeholder="请输入验证码" 
							clearable 
							prefix-icon="el-icon-unlock"
							v-model="user.captcha" 
							style="flex:1;"
						></el-input>
						<img 
							:src="codeUrl" 
							@click="reload" 
							class="captcha-img" 
						/>
					</div>
				</el-form-item>

				<div class="login-btn-box">
					<el-button 
						type="primary" 
						@click="login" 
						size="large" 
						style="width: 100%" 
						:loading="loading"
						class="login-btn"
					>
						<span v-if="!loading">登 录</span>
						<span v-else>登录中...</span>
					</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
import api from '@/api/api.js';
export default {
	data() {
		return {
			passwordVisible: false, // 密码显隐控制
			loading: false,		
			codeUrl: '/admin/common/captcha?rand=' + new Date().getTime(),
			user: {
				username: '',
				password: '',
				captcha: '',
			},
			count: '',
			show: true,
			timer: '',
			form: {
				phoneCode: ''
			}
		}
	},
	mounted() {
  document.body.setAttribute('data-login-page', 'true');
  this.is_login();
},
beforeDestroy() {
  // 离开登录页时移除属性（可选）
  document.body.removeAttribute('data-login-page');
},
	methods: {
		reload() {
			this.codeUrl = '/admin/common/captcha?rand=' + new Date().getTime()
		},
		getCode() {
			console.log(this.form.phone);
			if (!this.timer) {
				this.count = 60;
				this.show = false;
				this.timer = setInterval(() => {
					if (this.count > 0 && this.count <= 60) {
						this.count--;
					} else {
						this.show = true;
						clearInterval(this.timer);
						this.timer = null;
					}
				}, 1000);
			}
		},
		login() {
			if (!this.user.username) {
				this.$message.error('请输入用户名');
				return false;
			}
			if (!this.user.password) {
				this.$message.error('请输入密码');
				return false;
			}
			if (!this.user.captcha) {
				this.$message.error('请输入验证码');
				return false;
			}
			this.loading = true;
			api.common.login(this.user).then((res) => {
				this.reload(); 
				this.loading = false;
				if (res.data.code == 1000) {
					localStorage.setItem("login", 1);
					localStorage.removeItem('tags');
					this.$store.commit('login', true);
					localStorage.setItem('menu', JSON.stringify(res.data.menu));
					localStorage.setItem('token', JSON.stringify(res.data.data.token));
					localStorage.setItem('userData', JSON.stringify(res.data.data));
					setTimeout(() => {
						this.$router.push('/index')
					}, 1000)
				}
			}).catch(function (res) {
				console.log(res)
			})
		},
		is_login() {
			api.common.is_login().then(res => {
				if (res.data.code === 200) {
					localStorage.setItem("login", 1);
					localStorage.removeItem("tags");
					this.$store.commit('login', true);
					this.$router.push('/index');
				}
			}).catch(err => {
				console.log(err);
			})
		}
	},
	created() {
		this.is_login();
	}
}
</script>
<style lang="less">
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}
html[data-login-page],
body[data-login-page] {
  background-color: transparent !important;
}
/* 动态渐变背景核心 */
.container {
	width: 100%;
	height: 100vh;
	padding: 0 16px;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	overflow: hidden;
}

/* 动态流动背景 */
.container::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 400%;
	height: 400%;
	background: linear-gradient(
		-45deg,
		#667eea,
		#764ba2,
		#f093fb,
		#4facfe,
		#43e97b,
		#667eea
	);
	animation: bgGradient 18s ease infinite;
	z-index: -1;
}

/* 背景动画 */
@keyframes bgGradient {
	0% {
		transform: translate(-50%, -50%) rotate(0deg);
	}
	50% {
		transform: translate(-50%, -50%) rotate(180deg);
	}
	100% {
		transform: translate(-50%, -50%) rotate(360deg);
	}
}

// 登录卡片
.login-card {
	width: 100%;
	max-width: 420px;
	background: #ffffff;
	border-radius: 20px;
	padding: 50px 40px;
	box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
	animation: fadeIn 0.5s ease;
	position: relative;
	z-index: 10;
}

// 标题
.login-header {
	text-align: center;
	margin-bottom: 40px;
	h2 {
		font-size: 26px;
		font-weight: bold;
		color: #333;
		margin-bottom: 6px;
	}
	p {
		font-size: 14px;
		color: #999;
	}
}

// 验证码行
.captcha-row {
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
}
.captcha-img {
	height: 40px;
	border-radius: 6px;
	cursor: pointer;
}

// 按钮
.login-btn-box {
	margin-top: 20px;
}

// 入场动画
@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(-20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

// 移动端适配
@media (max-width: 480px) {
	.login-card {
		padding: 36px 24px;
		border-radius: 16px;
	}
	.login-header h2 {
		font-size: 22px;
	}
	.captcha-img {
		height: 38px;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/login/index.vue